import * as React from "react"

import { cn } from "@/lib/utils"

/*
 * Controls are hairline-bounded and unfilled — no shadow. On dark sections
 * inputs go translucent (see index.css).
 */
const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-10 w-full rounded-lg border border-input bg-transparent px-3.5 py-2 text-[15px] font-normal tracking-[-0.1px] transition-colors duration-250 ease-brand file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-ring focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-40",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
